import React from 'react';

export interface AuthContextType {
    isAuthLoading: boolean,
    isAuthenticated: boolean,
    signin: (token: string) => void;
    logout: () => void;
}

export const AuthContext = React.createContext<AuthContextType>(null!);